import React, { useEffect, useState } from "react";
import { Tab, Tabs } from 'react-bootstrap';
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";
import AdminDashboard from "./admindashboard";
import EmployeeDoctorAppointment from "./employeeDoctorAppointment";
import EmployeeAppointments from "./employeeAppointments";
import "./hm-theme.css";

function EmployeeAppointmentsTab() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tabParam = searchParams.get("tab") || location.state?.tab;

  const [activeTab, setActiveTab] = useState(
    tabParam === "doctor" || tabParam === "doctor-appointments"
      ? "doctor-appointments"
      : "lab-appointments"
  );

  useEffect(() => {
    if (tabParam === "doctor" || tabParam === "doctor-appointments") {
      setActiveTab("doctor-appointments");
    } else if (tabParam === "lab" || tabParam === "lab-appointments") {
      setActiveTab("lab-appointments");
    }
  }, [tabParam]);

  return (
    <div>
      <AdminDashboard />

      <div className="col-12 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-page-wrapper">

          {/* Page Header */}
          <div className="hm-page-header mb-4">
            <div>
              <h2 className="hm-page-title">
                <i className="material-icons">calendar_month</i>
                My Appointments
              </h2>
              <p className="hm-page-subtitle">Manage your lab and doctor appointments</p>
            </div>
          </div>

          {/* Tab Card */}
          <div className="hm-card">
            <div className="hm-card-body p-0">
              <div className="hm-tabs">
                <Tabs
                  id="employee-appointment-tabs"
                  activeKey={activeTab}
                  onSelect={(tab) => setActiveTab(tab)}
                  className="px-3 pt-2"
                >
                  <Tab
                    eventKey="lab-appointments"
                    title={
                      <span className="d-flex align-items-center gap-2">
                        <i className="material-icons" style={{ fontSize: "1rem" }}>biotech</i>
                        Lab Appointments
                      </span>
                    }
                  >
                    <div className="p-3">
                      {activeTab === 'lab-appointments' && (
                        <EmployeeAppointments />
                      )}
                    </div>
                  </Tab>

                  <Tab
                    eventKey="doctor-appointments"
                    title={
                      <span className="d-flex align-items-center gap-2">
                        <i className="material-icons" style={{ fontSize: "1rem" }}>medical_services</i>
                        Doctor Appointments
                      </span>
                    }
                  >
                    <div className="p-3">
                      {activeTab === "doctor-appointments" && (
                        <EmployeeDoctorAppointment />
                      )}
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default EmployeeAppointmentsTab;